import { useQuery } from "@tanstack/react-query";
import moment from "moment";
import { api } from "../api";

export function useCalendarMetrics(userId: string, selectedMonthDate: string, view?: string) {
  const month = moment(selectedMonthDate).format("MM");
  const year = moment(selectedMonthDate).format("YYYY");

  return useQuery({
    queryKey: ["calendarMetrics", userId, month, year, view],
    queryFn: () =>
      api.getCalendarMetrics(userId, {
        month,
        year,
        ...(view && { view }),
      }),
    enabled: !!userId && !!selectedMonthDate,
    staleTime: 10 * 60 * 1000, // 10 minutes - calendar data doesn't change frequently
    cacheTime: 30 * 60 * 1000, // 30 minutes - keep in cache longer
    refetchOnMount: false, // Don't refetch on mount if data is fresh
    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnReconnect: true, // Refetch when reconnecting to network
    keepPreviousData: true, // Keep last month's data visible while next month loads
  });
}
